import React, { useCallback, useState } from 'react';
import DataTable from 'react-data-table-component';
import { Btn, H4 } from '../../../AbstractElements';
import { Link } from 'react-router-dom';

export const columns = [
  {
    name: 'Name',
    selector: (row) => row['name'],
    sortable: true,
    center: false,
  },
  {
    name: 'Nr of beds',
    selector: (row) => row['nr_of_beds'],
    sortable: true,
    center: false,
  },
  {
    name: 'Hotel',
    selector: (row) => row['hotel'],
    sortable: true,
    center: false,
  },
  {
    name: 'Created at',
    selector: (row) => `${row.created_at}`,
    sortable: true,
    center: true,
  },
  {
    name: 'Actions',
    selector: (row) => row['actions'],
    sortable: false,
    center: true,
    width: '240px',
  },
];

export const dData = [
  {
    id: 1,
    name: 'Single',
    nr_of_beds: '1',
    hotel: 'Hotel 1',
    created_at: '2023/04/27',
    actions: (
      <div style={{ display: 'flex', gap: '0.2rem' }}>
        <Link to="/room-types/1/edit">
          <Btn color="primary">Edit</Btn>
        </Link>
        <Btn color="danger">Delete</Btn>
      </div>
    ),
  },
  {
    id: 2,
    name: 'Dopio',
    nr_of_beds: '2',
    hotel: 'Hotel 1',
    created_at: '2023/04/27',
    actions: (
      <div style={{ display: 'flex', gap: '0.2rem' }}>
        <Link to="/room-types/1/edit">
          <Btn color="primary">Edit</Btn>
        </Link>
        <Btn color="danger">Delete</Btn>
      </div>
    ),
  },
  {
    id: 3,
    name: 'Suite',
    nr_of_beds: '4',
    hotel: 'Hotel 1',
    created_at: '2023/04/27',
    actions: (
      <div style={{ display: 'flex', gap: '0.2rem' }}>
        <Link to="/room-types/1/edit">
          <Btn color="primary">Edit</Btn>
        </Link>
        <Btn color="danger">Delete</Btn>
      </div>
    ),
  },
];

const RoomTypesTable = () => {
  const [selectedRows, setSelectedRows] = useState([]);
  const [toggleDelete, setToggleDelet] = useState(false);
  const [data, setData] = useState(dData);

  const handleRowSelected = useCallback((state) => {
    setSelectedRows(state.selectedRows);
  }, []);

  const handleDelete = () => {
    if (window.confirm(`Are you sure you want to delete:\r ${selectedRows.map((r) => r.title)}?`)) {
      setToggleDelet(!toggleDelete);

      setData(
        data.filter((item) => selectedRows.filter((elem) => elem.id === item.id).length <= 0)
      );
      setSelectedRows('');
    }
  };
  return (
    <>
      {selectedRows.length !== 0 && (
        <div className={`d-flex align-items-center justify-content-between bg-light-info p-2`}>
          <H4 attrH4={{ className: 'text-muted m-0' }}>Delete Selected Data..!</H4>
          <Btn color="danger" onClick={handleDelete}>
            Delete
          </Btn>
        </div>
      )}
      <DataTable
        data={data}
        columns={columns}
        striped={true}
        center={true}
        pagination
        selectableRows
        onSelectedRowsChange={handleRowSelected}
        clearSelectedRows={toggleDelete}
      />
    </>
  );
};
export default RoomTypesTable;
